import React from "react";
import moment from "moment";
import useCountdownClock from "../../hooks/useCountdownClock";
import Util from "../../util/util";
import Box from "../layout/Box";

export default function LeagueWaiversCountdownClock() {
  const waiversClearDueDate = Util.getWaiversClearDueDate();
  const { clock } = useCountdownClock(waiversClearDueDate);

  const dateFormatted = moment(waiversClearDueDate).format(
    "dddd, MMMM D [at] h:mm a"
  );

  return (
    <Box title={"waivers clear date"} boxWidth={"33%"} centerContent={true}>
      <div
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          alignItems: "center",
        }}
      >
        <div>{dateFormatted}</div>
        <div style={{ fontSize: "1rem" }}>{clock}</div>
      </div>
    </Box>
  );
}
